import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Zap, CreditCard, ArrowRight, Flame, Clock } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
export function HookSection() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <section className="relative bg-matte text-white pb-10" data-id="element-38">
      {/* Sticky Top Bar */}
      <div className="sticky top-0 z-50 bg-red-600 py-2 px-4 shadow-md" data-id="element-39">
        <div className="container mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4" data-id="element-40">
          <div className="flex items-center gap-2" data-id="element-41">
            <Flame className="w-5 h-5 text-yellow-300 animate-pulse" data-id="element-42" />
            <span className="font-black text-white uppercase tracking-wide text-sm" data-id="element-43">
              70% OFF — Termina en:
            </span>
          </div>
          <div className="flex items-center gap-1 font-mono" data-id="element-44">
            <div className="bg-black/30 px-2 py-0.5 text-lg font-black min-w-[40px] text-center rounded-sm" data-id="element-45">
              {String(hours).padStart(2, '0')}
            </div>
            <span className="text-lg font-black" data-id="element-46">:</span>
            <div className="bg-black/30 px-2 py-0.5 text-lg font-black min-w-[40px] text-center rounded-sm" data-id="element-47">
              {String(minutes).padStart(2, '0')}
            </div>
            <span className="text-lg font-black" data-id="element-48">:</span>
            <div className="bg-black/30 px-2 py-0.5 text-lg font-black min-w-[40px] text-center rounded-sm" data-id="element-49">
              {String(seconds).padStart(2, '0')}
            </div>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 pt-8 relative z-10" data-id="element-50">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} className="max-w-3xl mx-auto text-center" data-id="element-51">
          <h1 className="text-3xl md:text-5xl font-black mb-6 leading-tight tracking-tight" data-id="element-52">
            ¿Seguís quemando perfiles caros y{' '}
            <span className="text-gold" data-id="element-53">cobrando de menos</span>?
          </h1>

          <div className="relative mx-auto max-w-sm mb-6" data-id="element-54">
            <img src="https://cdn.magicpatterns.com/uploads/geeQnDy3wQMCydhKCmLHyU/private_openrouter-generated-image-1776135192283.png" alt="Super Combo Carpintería en Aluminio" className="w-full h-auto drop-shadow-[0_0_25px_rgba(212,160,23,0.3)]" data-id="element-55" />
          </div>

          <p className="text-lg md:text-xl font-medium text-silver mb-8" data-id="element-56">
            El sistema que te lleva de cero a fabricar y vender aberturas de
            aluminio en Argentina — sin errores, sin desperdicios, sin cobrar de
            menos.
          </p>

          <motion.a href="#precios" whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} className="inline-flex items-center justify-center bg-gold text-matte font-black text-xl px-10 py-5 shadow-[0_0_20px_rgba(212,160,23,0.4)] hover:shadow-[0_0_30px_rgba(212,160,23,0.6)] transition-all uppercase w-full md:w-auto" data-id="element-57">
            Ver Oferta Ahora <ArrowRight className="ml-3 w-6 h-6" data-id="element-58" />
          </motion.a>

          <div className="flex flex-wrap justify-center gap-4 md:gap-6 mt-6 text-sm font-bold text-gray-400 uppercase tracking-wider" data-id="element-59">
            <div className="flex items-center" data-id="element-60">
              <ShieldCheck className="w-4 h-4 mr-1.5 text-gold" data-id="element-61" /> Garantía 7
              días
            </div>
            <div className="flex items-center" data-id="element-62">
              <Zap className="w-4 h-4 mr-1.5 text-gold" data-id="element-63" /> Acceso inmediato
            </div>
            <div className="flex items-center" data-id="element-64">
              <CreditCard className="w-4 h-4 mr-1.5 text-gold" data-id="element-65" /> Mercado Pago
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}